export default __webpack_public_path__ + "../staticImages/winefinder-sprite-occasion_hochzeit-2x.png";